import React, { useState, useEffect, useContext, Fragment } from "react";
import { Button } from "react-bootstrap";
import Layout from "components/sales/layout/layout";
import TableSection from "components/sales/tableSection/tableSection";
import Images from "assets/images/imageData";
import localization from "assets/localization/localization";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import ListFilters from "components/sales/ListFilters/ListFilters";

const ValetChatList = ({
  getAllValetRaisedTickets,
  allRaisedTicketsList = [],
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [listData, setListData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [roleId, setRoleId] = useState("");

  const Headers = [
    "Valet Name",
    "Phone Number",
    "Project ID",
    "Status",
    "Created At",
    "Action",
  ];

  useEffect(() => {
    const fetchData = async () => {
      if (roleId === 47) {
        setIsLoading(true);
        await getAllValetRaisedTickets(1,"RESPONDED", null);
        setIsLoading(false);
      }
      if (roleId === 26) {
        setIsLoading(true);
        await getAllValetRaisedTickets(1,"OPEN", null);
        setIsLoading(false);
      }
    };
    fetchData();
  }, [roleId]);

  console.log("Test new api:", allRaisedTicketsList);

  useEffect(() => {
    const tableData = [
      "id",
      "user_name",
      "user_phone_number",
      "project_id",
      "status",
      "created_at",
    ];

    setListData();
    if (allRaisedTicketsList && allRaisedTicketsList?.resultSets) {
      const data = allRaisedTicketsList?.resultSets?.data?.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({
            [key]: element[key],
          })),
          {
            Action: [
              { name: "View details", link: `${baseUrl}/valet-chat-list-view` },
            ],
          }
        )
      );
      data && setListData(data);
      setPageCount(
        Math.ceil(
          allRaisedTicketsList?.resultSets?.count /
            allRaisedTicketsList?.resultSets?.limit
        )
      );
    }
  }, [allRaisedTicketsList]);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    localStorage.setItem("getCampaignListing", JSON.stringify(filterData));
    // console.log('filterData:',filterData);
    // return false;
    setIsLoading(true);
    setFilterData(filterData);
    await getAllValetRaisedTickets(1,filterData, null);
    setIsLoading(false);
    filterToggle();
  };

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(true);
      (async () => {
        if (localStorage.getItem("roles")) {
          const roles = await JSON.parse(localStorage.getItem("roles"))[0].id;
          setRoleId(roles);
        }
      })();
      setIsLoading(false);
    }, 1000);
  }, []);

  const headerBtns = () => (
    <Fragment>
      {console.log("RoleID:",roleId )}
      {roleId === 26 && (
        <Button
          onClick={filterToggle}
          className="filter-hamburger filter-btn btn btn-transparent"
        >
          <img src={Images?.Filter} alt="" />
          {localization.showFilters}
        </Button>
      )}
    </Fragment>
  );

  const onPageChange = async (val) => {
    localStorage.setItem("getCampaignListing", JSON.stringify(filterData));
    setIsLoading(true);
    if (roleId === 47) {
      setIsLoading(true);
      await getAllValetRaisedTickets(val.selected + 1,"RESPONDED", null);
      setIsLoading(false);
    }
    if (roleId === 26) {
      setIsLoading(true);
      await getAllValetRaisedTickets(val.selected + 1,"OPEN", null);
      setIsLoading(false);
    }
    if(filterData && filterData.status){
      await getAllValetRaisedTickets(val.selected + 1,filterData?.status);
    }
    setIsLoading(false);
  };

  return (
    <Layout
      title={localization.valetChat}
      Buttons={headerBtns}
      className={false ? "requiredFileds" : ""}
      // isGoback
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        headers={Headers}
        pageCount={pageCount}
        onPageChange={onPageChange}
        isId={false}
      />
      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        ValetSupportFilter={true}
      />
    </Layout>
  );
};

export default ValetChatList;
